import { Button, DownloadLink } from 'components'
import { useRef } from 'react'
export default function FileAttach({ files = [], addFile = () => {}, removeFile = () => {}, accept = '*/*' }) {
  const inputFileRef = useRef(null)

  const changeFile = (e) => {
    const file = e.target.files[0]
    addFile(file)
    inputFileRef.current.value = ''
  }

  return (
    <>
      <div className="flex mt24">
        <Button type="button" text="파일첨부" className="full outline" onClick={() => inputFileRef.current.click()} />
      </div>
      <input type="file" ref={inputFileRef} style={{ display: 'none' }} onChange={changeFile} accept={accept} />
      <div className="mt8">
        {files.map((file, index) => (
          <DownloadLink
            icon="true"
            text={file.name || file.fileNm}
            remove={false}
            key={`file_${index}`}
            onDelete={() => removeFile(index)}
          />
        ))}
      </div>
    </>
  )
}
